import React from "react";
import PropTypes from "prop-types";
import OkInput from "shared/components/oknf/OkInput";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { VALIDATION_TIMEOUT } from "apps/signup/util/constants";
import Str from "shared/components/Str";

let emailValidationTimeout = null;

const Email = (props) => {
	const {
		fieldName,
		value,
		onChange,
		validate,
		dismissSuggestion,
		hasError,
		feedback,
		suggestion,
		success,
		isUpdating,
	} = props;

	function _triggerValidation(field, inputValue) {
		clearTimeout(emailValidationTimeout);
		emailValidationTimeout = setTimeout(() => {
			validate(field, inputValue);
		}, VALIDATION_TIMEOUT);
	}

	function _onBlur() {
		if (!success) {
			validate(fieldName, value);
		}
	}

	function _onChangeAndValidate(field, inputValue) {
		onChange(field, inputValue);
		_triggerValidation(field, inputValue);
	}

	function _onInputChange(ev) {
		_onChangeAndValidate(fieldName, ev.target.value);
	}

	function _onSelectSuggestion() {
		_onChangeAndValidate(fieldName, suggestion);
		dismissSuggestion();
	}

	return (
		<div className="signup2017-email">
			<span className="signup2017-field-label">
				<Str>Email</Str>
			</span>

			<OkInput
				name="email"
				type="email"
				autoComplete="on"
				placeholder="your.email@example.com"
				value={value}
				className="signup2017-input"
				onChange={_onInputChange}
				autoFocus={process.env.PLATFORM === "desktop"}
				onBlur={_onBlur}
				error={hasError ? feedback : false}
				success={!hasError && !isUpdating && success}
			/>

			<CSSTransitionGroup
				className="signup2017-field-suggestion"
				transitionName="signup2017-suggestionTransition"
				transitionEnterTimeout={600}
				transitionLeaveTimeout={600}
			>
				{!!suggestion && !!feedback &&
					<div className="signup2017-field-suggestion">
						<div
							className="signup2017-field-suggestion-message"
							onClick={_onSelectSuggestion}
							role="button"
							tabIndex="-1"
						>
							{feedback}
						</div>
					</div>
				}
			</CSSTransitionGroup>
		</div>
	);
};

Email.propTypes = {
	fieldName: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	validate: PropTypes.func.isRequired,
	dismissSuggestion: PropTypes.func.isRequired,
	isUpdating: PropTypes.bool,
	hasError: PropTypes.bool,
	success: PropTypes.bool,
	feedback: PropTypes.string,
	suggestion: PropTypes.node,
};

Email.defaultProps = {
	isUpdating: false,
	hasError: false,
	success: false,
	feedback: "",
	suggestion: null,
};

export default Email;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Email/Email.jsx